const OpenButton = ({onClick}) => {
  return <button onClick={onClick} className="open-button-filter">Фильтр товаров</button>;
};

export default OpenButton;